<div class="flex-container-row">
  @if (label()) {
    <span>{{label()}}</span>
  }
  <mat-divider class="divider-{{offset()}}"></mat-divider>

</div>
